import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useRef } from 'react';
import { useSpring, animated, to } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';
import { mergeProps } from '../../utils/with-default-props';
import { withNativeProps } from '../../utils/native-props';
var classPrefix = "adm-floating-bubble";
var defaultProps = {
  axis: 'y'
};
export var FloatingBubble = function FloatingBubble(p) {
  var props = mergeProps(defaultProps, p);
  var boundaryRef = useRef(null);
  var buttonRef = useRef(null);
  /**
   * memoize the `to` function
   * inside a component that renders frequently
   * to prevent an unintended restart
   */

  var _useSpring = useSpring(function () {
    return {
      x: 0,
      y: 0,
      opacity: 1
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      _useSpring2$ = _useSpring2[0],
      x = _useSpring2$.x,
      y = _useSpring2$.y,
      opacity = _useSpring2$.opacity,
      api = _useSpring2[1];

  var bind = useDrag(function (state) {
    var nextX = state.offset[0];
    var nextY = state.offset[1];

    if (state.last && props.magnetic) {
      var boundary = boundaryRef.current;
      var button = buttonRef.current;
      if (!boundary || !button) return;
      var boundaryRect = boundary.getBoundingClientRect();
      var buttonRect = button.getBoundingClientRect();

      if (props.magnetic === 'x') {
        var compensation = x.goal - x.get();
        var leftDistance = buttonRect.left + compensation - boundaryRect.left;
        var rightDistance = boundaryRect.right - (buttonRect.right + compensation);

        if (rightDistance <= leftDistance) {
          nextX += rightDistance;
        } else {
          nextX -= leftDistance;
        }
      } else if (props.magnetic === 'y') {
        var _compensation = y.goal - y.get();

        var topDistance = buttonRect.top + _compensation - boundaryRect.top;
        var bottomDistance = boundaryRect.bottom - (buttonRect.bottom + _compensation);

        if (bottomDistance <= topDistance) {
          nextY += bottomDistance;
        } else {
          nextY -= topDistance;
        }
      }
    }

    api.start({
      x: nextX,
      y: nextY
    }); // active status

    api.start({
      opacity: state.active ? 0.8 : 1
    });
  }, {
    axis: props.axis === 'xy' ? undefined : props.axis,
    pointer: {
      touch: true
    },
    // the component won't trigger drag logic if the user just clicked on the component.
    filterTaps: true,
    // set constraints to the user gesture
    bounds: boundaryRef,
    from: function from() {
      return [x.get(), y.get()];
    }
  });
  return withNativeProps(props, React.createElement("div", {
    className: classPrefix
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-boundary-outer")
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-boundary"),
    ref: boundaryRef
  })), React.createElement(animated.div, Object.assign({}, bind(), {
    style: {
      opacity: opacity,
      transform: to([x, y], function (x, y) {
        return "translate(".concat(x, "px, ").concat(y, "px)");
      })
    },
    onClick: props.onClick,
    className: "".concat(classPrefix, "-button"),
    ref: buttonRef
  }), props.children)));
};